import React from 'react';
import './Support.css';

const Support = () => {
  return (
    <div className="support-page">
      <h1 className="support-title">Get In Touch</h1>
      <div className="support-subtitle">
        We're here to help with your coding journey. Reach out for support, inquiries, or feedback.
      </div>
      <div className="support-card-container">
        <div className="support-card">
          <div className="support-icon email">✉️</div>
          <h2>Email Us</h2>
          <p>For general inquiries and support</p>
          <a href="mailto:flashcodehelp@gmail.com" className="support-link">flashcodehelp@gmail.com</a>
        </div>
        {/* <div className="support-card">
          <div className="support-icon call">💬</div>
          <h2>Schedule a Call</h2>
          <p>Discuss your needs with our team</p>
          <a href="#" className="support-btn">Talk To Us →</a>
        </div> */}
      </div>
    </div>
  );
};

export default Support; 